import type { TFunction } from 'i18next'

import type { VolunteeringOpportunity } from '@percent/partner-dashboard/services/workplaceGiving/workplaceGivingService.types'

export function formatAttendeesCount(opportunity: VolunteeringOpportunity, t: TFunction): string {
  const count = `${opportunity.participants.count}${
    opportunity.participants.spots ? `/${opportunity.participants.spots}` : ''
  }`

  if (opportunity.participantCounts?.waitlisted) {
    return `${count} ${t('volunteering.waitlistedCount', { count: opportunity.participantCounts.waitlisted })}`
  }

  return count
}
